/*
 * Wait List Ctrl
 * Collects CH emails to join waitlist
 */

module.controller('waitListCtrl', ['$scope', '$state', '$http', '$stateParams',
  function ($scope, $state, $http, $stateParams){
    $scope.joinEmailSuccess = false;
    $scope.attempted = false;

    $scope.submitEmail = function(joinForm){
      if(joinForm.$valid){
        $scope.joinEmailSuccess = true;
        var userEmail = $scope.formData.joinEmail;

        var eventParams = {
                           'Email': userEmail,
                          };

        var peopleParams = {
                          '$email': userEmail,
                          'Signup Type': 'waiting list',
                           };

      } else {
        $scope.attempted = true;
      }
    };

  }]);
